import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Row = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space['20px']};
  width: 100%;
  padding: ${space['20px']};
  border: 2px solid
    ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.default)};
  border-radius: ${layout.borderRadiusXl};
  background: ${colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    border-color: ${semantic.border.selected};
  }
`;

export const Info = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[1]};
`;

export const RowLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  text-align: left;
`;

export const RowSublabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const Indicator = styled.span<{ $selected: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid
    ${({ $selected }) => ($selected ? semantic.border.selected : semantic.border.default)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: transparent;
  transition: border-color 0.15s ease;

  &::after {
    content: '';
    display: ${({ $selected }) => ($selected ? 'block' : 'none')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: ${semantic.text.primary};
  }
`;
